export default __webpack_public_path__ + "src/images/content/presentation-4-18acf2eed5436d44bf53bd062b439655.png";